import { QueryKey, useQuery, UseQueryOptions } from 'react-query'

import api from 'api/index'
import { ApiError } from 'api/types/ApiError'
import { User } from 'types/domain/User'

import { USERS_ENDPOINT_KEY } from './constants'
import { RequestHeadersWithGdsScope } from '../types/RequestHeadersWithGdsScope'

type GetUserResourceRequestParams = {
  id: number
}

type GetUserResourceResponse = {
  data: User
}

export const getUserResource = ({
  params,
  headers
}: {
  params: GetUserResourceRequestParams
  headers?: RequestHeadersWithGdsScope
}): Promise<GetUserResourceResponse> =>
  api.get(`/${USERS_ENDPOINT_KEY}/${params.id}`, { headers })

export const useGetUserResource = ({
  params,
  headers,
  queryOptions,
  customQueryKey,
}: {
  params: GetUserResourceRequestParams
  headers?: RequestHeadersWithGdsScope
  queryOptions?: UseQueryOptions<Awaited<ReturnType<typeof getUserResource>>, ApiError>
  customQueryKey?: QueryKey
}) =>
  useQuery(
    customQueryKey || [
      USERS_ENDPOINT_KEY,
      ...Object.values(params || {}),
      ...Object.values(headers || {}),
    ],
    () => getUserResource({ params, headers }),
    queryOptions,
  )
